import * as React from 'react';
import type { LocationWithCoordinates } from 'lib/types';
import type { BookingStep } from '@bondvet/types/booking';

export type BookingContextType = {
    citySlug?: string;
    locationSlug?: string;
    location?: LocationWithCoordinates;
    step: BookingStep;
};

const BookingContext = React.createContext<BookingContextType>({
    step: 'city',
});

export default BookingContext;
